{
  "FormEngineHttpRequestWfl": {
    "title": "HTTP-Anfrage",
    "description": "Formulardaten per HTTP-Request transportieren"
  },
  "mask": {
    "FormEngineHttpRequestWfl": {
      "description": "Beschreibung",
      "url": "URL",
      "method": "Methode",
      "authGroupTitle": "Genehmigung",
      "requestGroupTitle": "Anfrage",
      "responseType": "Antworttyp",
      "sourceType": "Quelle Typ",
      "storeResultAs": "Ergebnispfad",
      "storeResultAsPlaceholder": "z.B. Ergebnis",
      "storeErrorAs": "Fehlerpfad",
      "storeErrorAsPlaceholder": "z.B. Fehler"
    }
  }
}